export const SUCCESS_AMERIA_RESPONSE_CODE = "00";
export const APPLE_PAY_ID = 13;
export const CREDIT_CARD_ID = 5;
export const AMERIA_FORM = 'https://services.ameriabank.am/VPOS/Payments/Pay?id=PAYMENT_ID&lang=@lang';
export const AMERIA_FORM_APPLE_PAY = `${AMERIA_FORM}&type=${APPLE_PAY_ID}`;
export const AMERIA_FORM_CREDIT_CARD = `${AMERIA_FORM}&type=${CREDIT_CARD_ID}`;
export const PAYMENT_ID_NAME = 'PAYMENT_ID';

export const WITH_COMMISSION = 5.0;
export const WITHOUT_COMMISSION = 0.0;
